import { EscutaInicialInput } from 'graphql/types.generated'

import { EscutaInicialState } from './model'

export const convertEscutaInicialModelToInput = (
  atendimentoId: ID,
  cidadaoId: ID,
  values: EscutaInicialState
): EscutaInicialInput => ({
  id: atendimentoId,
  cidadaoId: cidadaoId,
  ciapId: values.motivoConsulta.ciap.id,
  motivoConsulta: values.motivoConsulta.texto,
  finalizadoEm: new Date().getTime(),
})
